import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { CitLicenceGeneratorComponent } from './cit-licence-generator/cit-licence-generator.component';

const appRoutes: Routes = [
    {
        path:'', children:[
            {path:'', component:CitLicenceGeneratorComponent}
        ]
    }
];

export const AppRoutingProviders: any[] = [{ provide: LocationStrategy, useClass: HashLocationStrategy }];
export const Routing: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes, { useHash: true}); 
